import DashboardAdmin from "./components/DashboardAdmin";
import DashboardSaller from "./components/DashboardSaller";
import DashboardConfirmator from "./components/DashboardConfirmator";
import DashboardLivreur from "./components/DashboardLivreur";
import AnnonceDashboard from "../../components/AnnonceDashboard";
import AnnonceYoucan from "../../components/AnnonceYoucan";
import { useAuth } from "../../context/AuthProvider";
import { appConfig } from '../../apiConfig';
import WoldMap from "./WoldMap";

export default function Dashboard() {
  const { role, user } = useAuth();

  return (
    <div className="relative" >

      <div className={`${user.role === 0 ? "top-56" : "top-0"} fixed right-28 max-md:right-10 opacity-20 z-0 w-[26%] max-lg:w-[50%] max-md:w-[60%] max-w-lg pointer-events-none`}>
        <div className="relative aspect-square rounded-full overflow-hidden shadow-[0_0_80px_-20px_rgba(10,179,156,0.35)]">
          {/* dotted map stretched to 2x width so the circle shows a centered, undistorted hemisphere */}
          <WoldMap
            className="absolute top-0 left-1/2 -translate-x-1/2 h-full w-[200%]"
            color="var(--color-primary-500)"
          />
          {/* sphere shading: soft highlight top-left, darker vignette bottom-right */}
          <div className="pointer-events-none absolute inset-0 rounded-full bg-[radial-gradient(circle_at_32%_28%,rgba(255,255,255,0.18),transparent_55%)]" />
          <div className="pointer-events-none absolute inset-0 rounded-full bg-[radial-gradient(circle_at_72%_78%,rgba(0,0,0,0.5),transparent_60%)]" />
          {/* thin edge ring so the circle reads as a distinct globe */}
          <div className="pointer-events-none absolute inset-0 rounded-full ring-1 ring-inset ring-black/10" />
        </div>
      </div>
      
      {role === 0 && appConfig.slug === "nextlead" ? <AnnonceYoucan /> : null}
      <AnnonceDashboard />
      { role === 0 && <DashboardSaller  />}
      {(role === 1 || role === 2) && <DashboardAdmin  />}
      { role === 3 && <DashboardConfirmator  />}
      { role === 4 && <DashboardLivreur  />}
    </div>
  );
}
